







































import {
  Vue,
  Component,
} from "@/shared/vuepack";
@Component({
  components: {}
})
export default class ExternalLinkWarningModal extends Vue {
  visible = false;
  pendingUrl = "";
  resolver = null as ((confirmed: boolean) => void) | null;

  open (url: string): Promise<boolean> {
    this.pendingUrl = url;
    this.visible = true;

    return new Promise(resolve => {
      this.resolver = resolve;
    });
  }

  onContinue (): void {
    this.visible = false;

    if (this.resolver) {
      this.resolver(true);
    }

    this.cleanup();
  }

  onCancel (): void {
    if (this.resolver) {
      this.resolver(false);
    }

    this.cleanup();
  }

  cleanup (): void {
    this.pendingUrl = "";
    this.visible = false;
    this.resolver = null;
  }
}
